export default function isNumber(num) {
  if (typeof num === "string") {
    return !isNaN(Number(num));
  } else if (typeof num === "number") {
    return !isNaN(num);
  }
  return false;
}
